<app-ehe-header [auth]="true"></app-ehe-header>
<section class="faq-wrapper general-wrapper">
	<div class="container">
		<div class="row">
			<div class="col-md-3 g-left">
				<ul class="menu">
					<li class="font-thick text-link" [routerLink]="['/faq/questions']">
						<span [translate]="'faq.title'">Contact</span>
					</li>
					<ng-template [ngxPermissionsOnly]="[MODULE_LEVEL.HM, MODULE_LEVEL.PW]">
						<li>
							<span class="italic font-thick">
								<span [translate]="'faq.personal-health-coaching.title'">Personal Health Coaching</span>
							</span>
							<div>
								<a
									class="link"
									href="mailto:CoachMe@ehe.health"
									appEheAnalytics
									[data]="{
										pageUrl: '/faq/questions',
										redirectedTo: '/faq/questions',
										componentName: 'faq',
										id: 'faq personal health coaching',
										placement: 'faq'
									}">
									<span class="clickable font-normal">
										<span [translate]="'faq.personal-health-coaching.email'" class="pr-1"
											>CoachMe&#64;ehe.health
										</span>
									</span>
								</a>
								<span [translate]="'faq.static-text.or-call'"> or call </span>
							</div>
							<div>
								<span [translate]="'faq.personal-health-coaching.phone'">866.657.5697, Monday - Friday </span>
							</div>
							<div>
								<span [translate]="'faq.personal-health-coaching.time'">9:00 AM to 5:00 PM EST </span>
							</div>
						</li>
					</ng-template>
					<li>
						<div class="italic font-thick">
							<span [translate]="'faq.physicians.title'">Physicians</span>
						</div>
						<div>
							<a
								class="link"
								href="mailto:MemberServices@ehe.health"
								appEheAnalytics
								[data]="{
									pageUrl: '/faq/questions',
									redirectedTo: '/faq/questions',
									componentName: 'faq',
									id: 'faq physicians'
								}">
								<span class="clickable">
									<span [translate]="'faq.physicians.email'" class="pr-1">NetworkSuccess&#64;ehe.health </span>
								</span>
							</a>
							<span [translate]="'faq.static-text.or-call'">or call</span>
						</div>
						<div>
							<span [translate]="'faq.physicians.phone'">Network Success at 844.944.2802</span>
						</div>
					</li>
					<li>
						<div class="italic font-thick">
							<span [translate]="'faq.other-questions.title'">Other EHE or myEHE Questions </span>
						</div>
						<div>
							<a
								class="link"
								href="mailto:MemberServices@ehe.health"
								appEheAnalytics
								[data]="{
									pageUrl: '/faq/questions',
									redirectedTo: '/faq/questions',
									componentName: 'faq',
									id: 'faq other questions'
								}">
								<span class="clickable">
									<span [translate]="'faq.other-questions.email'" class="pr-1">MemberServices&#64;ehe.health </span>
								</span>
							</a>
							<span [translate]="'faq.static-text.or-call'">or call</span>
						</div>
						<div>
							<span [translate]="'faq.other-questions.phone'">Member Services at 800.362.8671 </span>
						</div>
					</li>
				</ul>
			</div>
			<div class="col-md-9 g-right">
				<div class="left-outline">
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
